













import { Component, Vue } from 'vue-property-decorator';
import UsersTable from '@/components/Users/UsersTable.vue';
import UserRulesModal from '@/components/Users/UserRulesModal.vue';

@Component({
  components: {
    UserRulesModal,
    UsersTable,
  },
})
export default class Users extends Vue {
  private onAddUserClick(): void {
    this.$store.dispatch('addEditUser/showModal');
  }

}
